document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  /* ── DOM refs ── */
  var drawer    = document.getElementById('CartDrawer');
  var overlay   = document.getElementById('CartOverlay');
  var closeBtn  = document.getElementById('CartDrawerClose');
  var continueBtn = document.getElementById('CartDrawerContinue');
  var body      = document.getElementById('CartDrawerBody');
  var footer    = document.getElementById('CartDrawerFooter');
  var totalEl   = document.getElementById('CartDrawerTotal');
  var countEl   = document.getElementById('CartDrawerCount');
  var loading   = document.getElementById('CartDrawerLoading');

  if (!drawer) return;

  /* Also update navbar badge */
  var navBadge  = document.querySelector('.navbar__cart-count');

  /* ── Helpers ── */
  function formatMoney(cents) {
    var amount = (cents / 100).toLocaleString('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return amount;
  }

  function setLoading(on) {
    loading.classList.toggle('active', on);
  }

  /* ── Open / Close ── */
  function openDrawer() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  /* ── Fetch cart from Shopify AJAX API ── */
  function fetchCart() {
    setLoading(true);
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCart(cart); })
      .catch(function() { body.innerHTML = '<p style="padding:1rem;color:#999;">Error al cargar el carrito.</p>'; })
      .finally(function() { setLoading(false); });
  }

  /* ── Render ── */
  function renderCart(cart) {
    var count = cart.item_count || 0;

    /* Update badges */
    countEl.textContent = count;
    if (navBadge) {
      navBadge.textContent = count;
      navBadge.classList.toggle('visible', count > 0);
    }

    if (count === 0) {
      footer.style.display = 'none';
      body.innerHTML = [
        '<div class="cart-drawer__empty">',
          '<svg class="cart-drawer__empty-icon" viewBox="0 0 56 56" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">',
            '<path d="M10 14h36l-4 22H14L10 14z" stroke-linecap="round" stroke-linejoin="round"/>',
            '<circle cx="20" cy="44" r="2.5" fill="currentColor" stroke="none"/>',
            '<circle cx="38" cy="44" r="2.5" fill="currentColor" stroke="none"/>',
            '<path d="M10 14L7 6H2" stroke-linecap="round"/>',
          '</svg>',
          '<p class="cart-drawer__empty-text">Tu carrito está vacío</p>',
        '</div>'
      ].join('');
      return;
    }

    footer.style.display = 'block';
    totalEl.textContent = formatMoney(cart.total_price);

    var html = '<ul class="cart-drawer__items">';
    cart.items.forEach(function(item) {
      var imgHtml = item.image
        ? '<img class="cart-drawer__item-img" src="' + item.image + '" alt="' + item.title.replace(/"/g,'') + '" width="72" height="72" loading="lazy">'
        : '<div class="cart-drawer__item-img-placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9l4-4 4 4 4-4 4 4"/><path d="M3 15l4 4 4-4 4 4 4-4"/></svg></div>';

      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="cart-drawer__item-variant">' + item.variant_title + '</span>'
        : '';

      html += [
        '<li class="cart-drawer__item" data-key="' + item.key + '">',
          imgHtml,
          '<div class="cart-drawer__item-info">',
            '<span class="cart-drawer__item-title">' + item.product_title + '</span>',
            variantHtml,
            '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>',
            '<div class="cart-drawer__qty">',
              '<button class="cart-drawer__qty-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Reducir cantidad" ' + (item.quantity <= 1 ? 'disabled' : '') + '>',
                '<svg width="12" height="2" viewBox="0 0 12 2" fill="currentColor"><rect width="12" height="2" rx="1"/></svg>',
              '</button>',
              '<span class="cart-drawer__qty-val">' + item.quantity + '</span>',
              '<button class="cart-drawer__qty-btn" data-action="increase" data-key="' + item.key + '" aria-label="Aumentar cantidad">',
                '<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor"><rect x="5" width="2" height="12" rx="1"/><rect y="5" width="12" height="2" rx="1"/></svg>',
              '</button>',
            '</div>',
          '</div>',
          '<button class="cart-drawer__item-remove" data-key="' + item.key + '" aria-label="Eliminar producto">',
            '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true"><path d="M10.5 3.5l-7 7M3.5 3.5l7 7" stroke-linecap="round"/></svg>',
          '</button>',
        '</li>'
      ].join('');
    });
    html += '</ul>';
    body.innerHTML = html;
  }

  /* ── Update quantity ── */
  var waNumber = drawer.dataset.whatsapp || '';

  function showCartAlert(msg) {
    var existing = document.getElementById('CartDrawerAlert');
    if (existing) existing.remove();
    var alert = document.createElement('div');
    alert.id = 'CartDrawerAlert';
    alert.style.cssText = 'background:#000927;color:#fff;font-family:var(--font-accent);font-size:0.75rem;font-weight:600;letter-spacing:0.05em;padding:0.75rem 1rem;text-align:center;line-height:1.4;border-bottom:1px solid rgba(246,152,50,0.3);';
    var html = msg;
    if (waNumber) {
      html += ' <a href="https://wa.me/' + waNumber + '?text=Hola%2C%20quiero%20saber%20si%20hay%20mas%20stock" target="_blank" rel="noopener" style="color:#F69832;text-decoration:underline;margin-left:4px;">WhatsApp &rarr;</a>';
    }
    alert.innerHTML = html;
    body.parentNode.insertBefore(alert, body);
    setTimeout(function() { if (alert.parentNode) alert.remove(); }, 5000);
  }

  function updateQty(key, qty) {
    setLoading(true);
    var prevQty = 0;
    var qtyEl = body.querySelector('[data-key="' + key + '"] .cart-drawer__qty-val');
    if (qtyEl) prevQty = parseInt(qtyEl.textContent, 10);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderCart(cart);
        /* Check if Shopify capped the quantity (stock limit) */
        if (qty > 0) {
          var updatedItem = cart.items.find(function(item) { return item.key === key; });
          if (updatedItem && updatedItem.quantity < qty) {
            showCartAlert('Solo hay ' + updatedItem.quantity + ' disponibles. Pregunta por mas en');
          }
        }
      })
      .catch(function() { fetchCart(); })
      .finally(function() { setLoading(false); });
  }

  /* ── Event delegation on body ── */
  body.addEventListener('click', function(e) {
    /* Qty buttons */
    var qtyBtn = e.target.closest('.cart-drawer__qty-btn');
    if (qtyBtn) {
      var key    = qtyBtn.dataset.key;
      var action = qtyBtn.dataset.action;
      var item   = body.querySelector('[data-key="' + key + '"]');
      if (!item) return;
      var current = parseInt(item.querySelector('.cart-drawer__qty-val').textContent, 10);
      var newQty  = action === 'increase' ? current + 1 : current - 1;
      if (newQty < 1) return;
      updateQty(key, newQty);
      return;
    }

    /* Remove button */
    var removeBtn = e.target.closest('.cart-drawer__item-remove');
    if (removeBtn) {
      updateQty(removeBtn.dataset.key, 0);
    }
  });

  /* ── Wiring: open cart icon ── */
  var cartIcon = document.getElementById('NavbarCart');
  if (cartIcon) {
    cartIcon.addEventListener('click', function(e) {
      e.preventDefault();
      openDrawer();
    });
  }

  /* ── Wiring: close ── */
  if (closeBtn)   closeBtn.addEventListener('click', closeDrawer);
  if (continueBtn) continueBtn.addEventListener('click', closeDrawer);
  if (overlay)    overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ── Global hook: auto-open on add to cart ── */
  document.addEventListener('cart:open', openDrawer);

  /* ── Expose globally so add-to-cart buttons can trigger it ── */
  window.O66YCart = {
    open:  openDrawer,
    close: closeDrawer,
    refresh: fetchCart
  };
});
